import React from "react";

interface HighlightQuotedTextProps {
  text: string;
}

export const HighlightQuotedText: React.FC<HighlightQuotedTextProps> = ({
  text,
}) => {
  const parts = text.split(/"([^"]+)"/g);

  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <span key={index} className="text-[#3B82F6]">
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  );
};
